import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { REPORTS_PAGE_CONSTANTS } from "../../config/constants";
import { CustomBreadcrumb } from "../../components";
import ReportsView from "./ReportsView";
import ReportsSchedule from "./ReportsSchedule";
import ReportsHistory from "./ReportsHistory";
import { ReportsStyled } from "./styled";
import { useLocation } from "react-router-dom";

const ReportsPage = () => {
  const [activeTab, setActiveTab] = useState("View");
  const [showTabs, setShowTabs] = useState(true);
  const onShowTabs = () => setShowTabs(true);
  const onHideTabs = () => setShowTabs(false);
  const location = useLocation();
  const [tabSelection, setTabSelection] = useState('');

  useEffect(() => {
    setTabSelection(location.state?.fromScreen);
  }, [location.state]);

  return (
    <CustomBreadcrumb
      header={REPORTS_PAGE_CONSTANTS.HEADER}
      currentPage={REPORTS_PAGE_CONSTANTS.BREADCRUMB_REPORTS}
      isFromLandingPage={tabSelection === "MainLanding"}
    >
      <ReportsStyled>
        <Tabs
          style={{ display: "flex" }}
          defaultActiveKey={activeTab}
          onSelect={(event) => setActiveTab(event)}
        >
          <Tab
            className="disabled"
            unmountOnExit
            eventKey="View"
            title="View"
            mountOnEnter={true}
          >
            <ReportsView
              tabSelection={tabSelection}
              onHideTabs={onHideTabs}
              onShowTabs={onShowTabs}
            />
          </Tab>
          <Tab
            className="disabled"
            unmountOnExit
            eventKey="Schedule"
            title="Schedule"
            mountOnEnter={true}
          >
            <ReportsSchedule
              tabSelection={tabSelection}
              onHideTabs={onHideTabs}
              onShowTabs={onShowTabs}
            />
          </Tab>
          <Tab
            className="disabled"
            unmountOnExit
            eventKey="Existing Schedules"
            title="Existing Schedules"
            mountOnEnter={true}
          >
            <ReportsHistory
              tabSelection={tabSelection}
              onHideTabs={onHideTabs}
              onShowTabs={onShowTabs}
            />
          </Tab>
        </Tabs>
      </ReportsStyled>
    </CustomBreadcrumb>
  );
};

export default ReportsPage;
